import { Box, Typography } from '@mui/material'
import React, { useMemo } from 'react'
import CopyLink from '../Content/ContentSubComponents/CopyLink'
import { useSearchParams } from 'react-router-dom';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

const DesktopHeaderCreator = ({ my_platform_page, selected_tab, ...props }) => {
    const [searchParams] = useSearchParams();
    const current_page_view = searchParams.get('page');

    const backButtonText = useMemo(() => {
        if (my_platform_page === 'add_product') {
            return 'Add new product'
        } else {
            switch (selected_tab) {
                case 'membership':
                    return my_platform_page === 'creation_flow' ? 'New Subscription Post' : 'Subscriptions'
                case 'async' || '1v1coaching':
                    return '1:1 Coaching'
                case 'paidDMs':
                    return 'Messages'
                case 'community':
                    return 'Community'
                case 'collections':
                    return my_platform_page === 'creation_flow' ? 'New Course' : 'Courses'
                case 'all':
                    return my_platform_page === 'creation_flow' ? 'Create Digital Product' : 'Digital Products'

                default:
                    break;
            }
        }
    }, [selected_tab, my_platform_page])

    const bottomTabTitle = useMemo(() => {
        switch (current_page_view) {
            case 'home':
                return 'Home';
            case 'platform':
                return 'My Platform';
            case 'preview':
                return 'Preview';
            case 'insights':
                return 'Insights';
            case 'more':
                return 'WithMe Apps';
            case 'payouts':
                return 'Payouts';
            case 'subscriptions':
                return 'Subscriptions';
            case 'digital_products':
                return 'Digital Products';
            case 'courses':
                return 'Courses';
            case 'customers':
                return 'Customers';
            case 'promo_codes':
                return 'Promotion Codes';
            case 'branding':
                return 'Branding';
            case 'examples':
                return 'Example Creators';
            case '1v1coaching':
                return '1:1 Coaching';
            case 'community':
                return 'Community';
            case 'messages':
                return 'Messages';
            case 'referrals':
                return 'Referrals';
            default:
                return null
        }
    }, [current_page_view])

    return (
        <Box sx={{ display: { xs: 'none', lg: 'flex' }, position: 'sticky', top: 0, zIndex: 1299, backgroundColor: 'var(--rebranding-background-color)', justifyContent: 'space-between', alignItems: 'center', padding: '12px 20px', 
        borderBottom: '1px solid #E4EBF6' 
        }}>
            {
                ((current_page_view === 'platform' && my_platform_page === 'creation_flow' && props.selected_tab !== '') || my_platform_page === 'add_product') ? (
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            pl: '10px'
                        }}
                    >
                        <ChevronLeftIcon
                            onClick={() => {
                                if (my_platform_page === 'add_product')
                                    props.setState({
                                        contentIsLoading: true,
                                        my_platform_page: 'home',
                                        selected_tab: ''
                                    });
                                else
                                    props.setState({
                                        my_platform_page: 'add_product'
                                    });
                            }}
                            sx={{ fontSize: { xs: '22px', lg: '24px' }, cursor: 'pointer' }}
                        />
                        <Typography
                            sx={{
                                fontSize: { xs: '16x', lg: '18px' },
                                fontWeight: '600',
                            }}
                        >
                            {backButtonText}
                        </Typography>
                    </Box>
                ) :
                    <Typography sx={{ color: '#222222', fontSize: { xs: '16x', lg: '18px' }, fontWeight: '600', textAlign: 'left', margin: '0px auto 0px 0px' }}>
                        {bottomTabTitle}
                    </Typography>
            }
            {current_page_view !== 'preview' && <CopyLink
                link={window.location.origin + '/' + props.influencer_username}
                showProtocol={false}
                containerStyle={{ margin: '0px', width: 'fit-content !important' }}
                style={{ border: 'none', outline: 'none', gap: '5px', backgroundColor: 'transparent' }}
                linkStyle={{ fontSize: '16px', fontWeight: '500', color: 'var(--brand-color)', textAlign: 'left', lineHeight: '20px', }}
                tooltipPlacement={'bottom'}
            />}
        </Box>
    )
}

export default DesktopHeaderCreator